module.exports = __webpack_public_path__ + "img/twitter-logo-gray.2fc661ba.svg";